import { QueryLanguage } from "@contember/binding";
const disconnectAtBase = (baseEntity, parentEntity) => {
  const desugaredBase = QueryLanguage.desugarRelativeSingleEntity(baseEntity, parentEntity.environment);
  parentEntity.disconnectEntityAtField(desugaredBase.hasOneRelationPath[0].field);
};
export {
  disconnectAtBase
};
//# sourceMappingURL=disconnectAtBase.js.map
